import * as React from "react";
import { Builder } from "@builder.io/react";
import PrimaryNavMenu from "@components/RedesignComponents/PrimaryNavMenu/PrimaryNavMenu";
import { segmentTrack } from "@utils/segment/segment-track";
import { navigate } from "gatsby";
import { useNavMobile } from "@sp-state/useNavMobile/useNavMobile";

type PrimaryNavMenuWrapperType = {
  noSticky?: boolean;
  hiddenMobile?: boolean;
  hiddenDesktop?: boolean;
};

const PrimaryNavMenuWrapper: React.FC<PrimaryNavMenuWrapperType> = ({
  noSticky,
  hiddenMobile,
  hiddenDesktop,
}) => {
  const setOpen = useNavMobile(state => state.setOpen);

  const onClick = (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>,
    extraData?: {
      [key: string]: string;
    },
    eventName: string = "Main Nav Clicked"
  ) => {
    e.preventDefault();

    const { currentTarget } = e;

    const isAnchor = currentTarget instanceof HTMLAnchorElement;

    if (!isAnchor) return;

    const isNewTab = currentTarget.target === "_blank";

    const target = isNewTab ? currentTarget.href : currentTarget.pathname;

    segmentTrack(eventName, {
      action: "Clicked",
      initiator: "User",
      object: "Main Nav",
      source_application: "Marketing",
      url: window.location.pathname,
      target: isAnchor ? target : "",
      text: currentTarget.textContent || "",
      ...extraData,
    });

    if (isNewTab) {
      return window.open(target, "_blank");
    }

    if (target === window.location.pathname) {
      setTimeout(() => {
        setOpen(false);
        document.body.style.overflow = "visible";
      }, 200);
    }

    const determineRouterUrl =
      new URL(document.baseURI).origin ===
      new URL(e.currentTarget?.href, document.baseURI).origin;

    if (!determineRouterUrl) {
      return (window.location.href = e.currentTarget?.href);
    }

    return navigate(target);
  };

  return (
    <PrimaryNavMenu
      onClickHandler={onClick}
      noSticky={noSticky}
      hiddenMobile={hiddenMobile}
      hiddenDesktop={hiddenDesktop}
    />
  );
};

export default PrimaryNavMenuWrapper;

export const RegisterPrimaryNavMenu = () => {
  Builder.registerComponent(PrimaryNavMenuWrapper, {
    name: "primaryNavMenu",
  });
};
